import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios'
import BootSpinner from '@/components/Spinner/BootSpinner'
import FrenteLoja from '@/views/FrenteLoja'

store.$http = axios.create({ baseURL: process.env.NODE_ENV !== 'production' ? 'https://localhost:21158/api' : 'https://enobairro.com/api', withCredentials: true })

async function Boot() {
  createApp(BootSpinner).mount('#app')
  let loaded = await store.dispatch('Boot', window.location.href)
  if(loaded) {
    document.title = store.getters.Empresa.metatitle === '' ? 'enb' : store.getters.Empresa.metatitle

    let metaDescription = document.createElement('meta')
    metaDescription.name = 'description'
    metaDescription.content = store.getters.Empresa.metadescription === '' ? 'enb' : store.getters.Empresa.metadescription
    document.head.appendChild(metaDescription)

    if(!store.getters.Empresa.frenteloja) {
      router.addRoute({
        name: 'Frente de loja',
        path: '/desativado',
        component: FrenteLoja
      })
    }
    createApp(App).use(router).use(store).mount('#app')
  }
}

Boot()
